import {Component, Input, OnInit} from '@angular/core';
import {IProduct} from '../../../../shared/models';
import {UtilsService} from '../../../../shared/services';

@Component({
    selector: 'app-product-features',
    templateUrl: './product-features.component.html',
    styleUrls: ['./product-features.component.less']
})
export class ProductFeaturesComponent implements OnInit {

    @Input() product: IProduct;

    dimensionExist = false;
    featuresExist = false;
    assemblyExist = false;
    careExist = false;
    returnPolicyExist = false;
    isSingleDimension: boolean;

    activeFeatureTab = 'features';
    features: any;
    assembly: any;
    care: any;


    constructor(
        private utils: UtilsService,
    ) {
    }

    ngOnInit() {
        this.isSingleDimension = this.product.dimension.length === 1;
        this.featuresExist = this.utils.checkDataLength(this.product.features);
        if (this.product.product_assembly != null) {
            this.assemblyExist = this.utils.checkDataLength(
                this.product.product_assembly
            );
        }
        if (this.product.product_care != null) {
            this.careExist = this.utils.checkDataLength(this.product.product_care);
        }
        this.returnPolicyExist = !!this.product.return_policy;
        this.dimensionExist = this.product.dimension.length > 0;
        this.assembly = this.utils.compileMarkdownText(this.product.product_assembly);
        this.care = this.utils.compileMarkdownText(this.product.product_care);
        this.features = this.utils.compileMarkdown(this.product.features);
        this.setFeatureTab();
    }

    selectFeatureTab(tab) {
        this.activeFeatureTab = tab;
    }

    setFeatureTab(){
       if(this.featuresExist){
            this.activeFeatureTab = 'features';
        }else  if(this.dimensionExist){
            this.activeFeatureTab = 'dimensions';
        }else if(this.assemblyExist){
            this.activeFeatureTab = 'assembly';
        }else if(this.careExist){
            this.activeFeatureTab = 'care';
        }else if(this.returnPolicyExist){
            this.activeFeatureTab = 'returns';
        }
    }
}
